import React, { useEffect, useState } from 'react'
import Axios from 'axios'
import { parse, format } from 'date-fns'
import Table from '../table'
import DataLayout from '../data-layout'

const SpendingByVendorNo = ({
  match: {
    params: { year, vendorNo }
  },
  location
}) => {
  const [data, setData] = useState([])

  useEffect(() => {
    const loadData = async () => {
      const result = await Axios.get(`/GetVendorSpending/${year}/${vendorNo}`)
      const _data = result.data.map(d => ({
        name: d.InvoiceDesc.trim(),
        checkDate: d.CheckDate
          ? format(parse(d.CheckDate, 'MM/dd/yyyy', new Date()), 'yyyy-MM-dd')
          : '',
        subCategory: d.ObjectDescription.trim(),
        fund: d.FundSegDesc.trim(),
        invoiceNo: d.VendorInvoiceNo.trim(),
        data: d.Amount,
        checkNo: d.CheckNo,
        purchaseOrder: d.OrderNo
      }))
      setData(_data.sort((a, b) => a.checkDate.localeCompare(b.checkDate)))
    }

    loadData()
  }, [location.search, vendorNo, year])

  return (
    <DataLayout year={year}>
      <Table
        data={{
          headers: [
            {
              title: 'Description',
              dataKey: 'name'
            },
            {
              title: 'Fund',
              dataKey: 'fund'
            },
            {
              title: 'SubCategory',
              dataKey: 'subCategory'
            },
            {
              title: 'Invoice',
              dataKey: 'invoiceNo'
            },
            {
              title: 'Check',
              dataKey: 'checkNo'
            },
            {
              title: 'Date',
              dataKey: 'checkDate'
            },
            {
              title: 'Purchase Order',
              dataKey: 'purchaseOrder'
            },
            {
              title: 'Amount',
              dataKey: 'data'
            }
          ],
          data,
          defaultSort: {
            field: 'checkDate',
            ascending: true
          }
        }}
      />
    </DataLayout>
  )
}

export default SpendingByVendorNo
